/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N30 } from '@atlaskit/theme/colors';
var separator = css({
  background: "var(--ds-border, ".concat(N30, ")"),
  width: '1px',
  height: '20px',
  margin: "0 ".concat("var(--ds-space-050, 4px)"),
  alignSelf: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
export default (function () {
  return jsx("div", {
    css: separator,
    className: "separator"
  });
});